import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { PatrolRobloxExperienceSwitcherComponent } from '../../components/patrol-roblox-cockpit/patrol-roblox-experience-switcher/patrol-roblox-experience-switcher.component';
import { PatrolRobloxModQueueComponent } from '../../components/patrol-roblox-cockpit/patrol-roblox-mod-queue/patrol-roblox-mod-queue.component';
import { PatrolRobloxPoliciesComponent } from '../../components/patrol-roblox-cockpit/patrol-roblox-policies/patrol-roblox-policies.component';
import { PatrolRobloxStudioBridgeComponent } from '../../components/patrol-roblox-cockpit/patrol-roblox-studio-bridge/patrol-roblox-studio-bridge.component';
import { PatrolRobloxUniverseOverviewComponent } from '../../components/patrol-roblox-cockpit/patrol-roblox-universe-overview/patrol-roblox-universe-overview.component';
import {
  PatrolRobloxCockpitService,
  PatrolRobloxCockpitTab,
} from '../../services/patrol-roblox-cockpit.service';

@Component({
  selector: 'app-patrol-roblox',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    TranslatePipe,
    PatrolRobloxExperienceSwitcherComponent,
    PatrolRobloxUniverseOverviewComponent,
    PatrolRobloxStudioBridgeComponent,
    PatrolRobloxPoliciesComponent,
    PatrolRobloxModQueueComponent,
  ],
  templateUrl: './patrol-roblox.component.html',
  styleUrl: './patrol-roblox.component.scss',
})
export class PatrolRobloxComponent implements OnInit, OnDestroy {
  #cockpit = inject(PatrolRobloxCockpitService);

  ngOnInit(): void {
    this.#cockpit.startBridgePolling();
  }

  ngOnDestroy(): void {
    this.#cockpit.stopBridgePolling();
  }

  readonly selectedExperience = this.#cockpit.selectedExperience;
  readonly activeTab = this.#cockpit.activeTab;

  readonly tabs: ReadonlyArray<{
    id: PatrolRobloxCockpitTab;
    labelKey: string;
  }> = [
    { id: 'overview', labelKey: 'app.patrol.roblox.cockpit.tabs.overview' },
    { id: 'studio', labelKey: 'app.patrol.roblox.cockpit.tabs.studio' },
    { id: 'policies', labelKey: 'app.patrol.roblox.cockpit.tabs.policies' },
    { id: 'queue', labelKey: 'app.patrol.roblox.cockpit.tabs.queue' },
  ];

  setTab(tab: PatrolRobloxCockpitTab): void {
    this.#cockpit.setActiveTab(tab);
  }
}
